
import * as api from "../../constant/NewAPI";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import Utils from "../../constant/Utils";
import Swal from "sweetalert2";

// import * as api from "../../constant/API";

const BarCount = () => {

    const [countList, setCountList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        setIsLoading(true);
        setTimeout(() => {
            insSportCount();
        }, 1000)
    }, [])

    function insSportCount() {
        const getCountByYear = api.instCountByYear;
        fetch(getCountByYear, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((cntResponse) => cntResponse.json())
            .then((cntResult) => {
                if (cntResult.error == true) {
                    if (cntResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(cntResult.message)
                } else {
                    setCountList(cntResult.data)
                    setIsLoading(false);
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the institute count by year list", error)
                setIsLoading(false);
            })
    }

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 2000 + 1 }, (_, i) => 2000 + i); // Generate years from 2000 to the current year

    const optionsBar = {
        chart: {
            type: "bar",
            height: 350,
            stacked: false,
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        plotOptions: {
            bar: {
                columnWidth: "40%",
                colors: {
                    ranges: [
                        {
                            from: 0,
                            to: 100,
                            color: "#1eb0d5",
                        },
                    ],
                },
                horizontal: false,
                barHeight: "80%",
            },
        },
        stroke: {
            show: true,
            width: 0,
            colors: ["transparent"],
        },
        series: [
            {
                name: "Grade Type Value",
                color: "#1eb0d5",
                data: countList,
            },
        ],
        xaxis: {
            title: {
                text: "Year", // Label for x-axis
                style: {
                    color: '#777',
                }
            },
            categories: years,
            labels: {
                style: {
                    colors: '#777',
                }
            }
        },
        yaxis: {
            title: {
                text: "Institution Count", // Label for y-axis
                style: {
                    color: '#777',
                }
            },
            labels: {
                style: {
                    colors: "#777",
                },
            },
            tickAmount: 5,
            min: 0,
            max: 100,
        },
        title: {
            text: "",
            align: "left",
            style: {
                fontSize: "18px",
            },
        },
    };

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="card dashboard-card statistic-simply">
                <div className="card-header card-header-info view-all-fav">
                    <div className="card-header-inner">
                        <h4>Earnings</h4>
                    </div>
                    <div className="sortby-section invoice-sort">
                        <div className="sorting-info">
                            <div className="sortby-filter-group court-sortby">
                                <div className="sortbyset week-bg me-0">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    {/* <div id="radial-chart" /> */}
                    <ReactApexChart
                        options={optionsBar}
                        series={optionsBar.series}
                        type="bar"
                        height={250}
                    />
                </div>
            </div>
        </>
    );
}

export default BarCount;